const Backbone  = window.Backbone;

class SubjectItemView extends Backbone.View {

    initialize() {
        this.template = _.template(`
            <div class="BrowseSubjects-item">
                <a class="BrowseSubjects-link js-browseSubject"
                href="<%= href %>"
                aria-label="<%= html('browseSubjects.titlesInCollection', {subject: subject, count: count}) %>">
                    <div class="collections-cell-count">
                        <span class="BrowseSubjects-count js-browseSubjectCount"><%= html('number', {num: count}) %></span>
                    </div>
                    <div class="collections-titles">
                        <span class="subject-name"><%= subjectLabel %></span>
                        <span class="sub-label"><%= subjectSubLabel %></span>
                    </div>
                </a>
            </div>`);
        this.render();
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));
    }
}

export default SubjectItemView;
